import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const Index = () => import("@/views/Index");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

//App
const LoginNew = () => import("@/views/Login");
const interest = () => import("@/views/SignUp");

const Dashboard = () => import('@/views/Dashboard')
const Setting = () => import('@/views/Setting')
const MyRecord = () => import('@/views/MyRecord')
const ApplyLeave = () => import('@/views/ApplyLeave')
const ApplyTimeOff = () => import('@/views/ApplyTimeOff')
const ApplyClaim = () => import('@/views/ApplyClaim')
const ApplyFinancialClaim = () => import('@/views/ApplyFinancialClaim')
const ApplySalary = () => import('@/views/ApplySalary')
const Announcement = () => import('@/views/Announcement')
const TeamCalendar = () => import('@/views/TeamCalendar')
const Performance = () => import('@/views/Performance')
const InviteFriend = () => import('@/views/InviteFriend')
const AttendanceTimesheet = () => import('@/views/AttendanceTimesheet')
const ShiftCalendar = () => import('@/views/ShiftCalendar')
const ForgotPassword = () => import('@/views/ForgotPassword')
const VerifyPassword = () => import('@/views/VerifyPassword')
const VerifyEmail = () => import('@/views/VerifyEmail')
const Register = () => import('@/views/Register')
const ResetPassword = () => import('@/views/ResetPassword')
const RegisterStaff = () => import('@/views/RegisterStaff')
const AddStaff = () => import('@/views/AddStaff')
const SettingCompany = () => import('@/views/SettingCompany')
const SettingDepartment = () => import('@/views/SettingDepartment')
const SettingNotification = () => import('@/views/SettingNotification')
const SettingEvaluation = () => import('@/views/SettingEvaluation')
const SettingLeave = () => import('@/views/SettingLeave')
const SettingClaim = () => import('@/views/SettingClaim')

const SettingProfile = () => import('@/views/SettingProfile')
const SettingPersonalDetail = () => import('@/views/SettingPersonalDetail')
const SettingEmployment = () => import('@/views/SettingEmployment')
const SettingContact = () => import('@/views/SettingContact')
const SettingFamilyDetail = () => import('@/views/SettingFamilyDetail')
const SettingCompensation = () => import('@/views/SettingCompensation')
const SettingDocument = () => import('@/views/SettingDocument')
const SettingEquipment = () => import('@/views/SettingEquipment')
const SettingLeavePolicy = () => import('@/views/SettingLeavePolicy')
const SettingClaimPolicy = () => import('@/views/SettingClaimPolicy')
const SettingDisciplinary = () => import('@/views/SettingDisciplinary')
const SettingAppSetting = () => import('@/views/SettingAppSetting')

const ApprovalLeave = () => import('@/views/ApprovalLeave')
const ApprovalClaim = () => import('@/views/ApprovalClaim')
const ApprovalTimeOff = () => import('@/views/ApprovalTimeOff')
const ApprovalFinancialClaim = () => import('@/views/ApprovalFinancialClaim')
const ApprovalOvertimeClaim = () => import('@/views/ApprovalOvertimeClaim')

const SettingAttendance = () => import('@/views/SettingAttendance')
const SettingSubscription = () => import('@/views/SettingSubscription')
const SettingYearlyForm = () => import('@/views/SettingYearlyForm')
const SettingPayment = () => import('@/views/SettingPayment')
const SalaryPayroll = () => import('@/views/SalaryPayroll')
const PaymentVoucher = () => import('@/views/PaymentVoucher')

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
      {
        path: '/',
        name: 'Login',
        component: LoginNew, // Directly use Homepage component for root path
      },
      {
        path: '/',
        component: TheContainer,
      children: [
       
        {
          path: 'Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'MyRecord',
          name: 'MyRecord',
          component: MyRecord
        },
        {
          path: 'RegisterStaff',
          name: 'RegisterStaff',
          component: RegisterStaff
        },
        {
          path: 'ApprovalLeave',
          name: 'ApprovalLeave',
          component: ApprovalLeave
        },
        {
          path: 'ApprovalTimeOff',
          name: 'ApprovalTimeOff',
          component: ApprovalTimeOff
        },
        {
          path: 'ApprovalClaim',
          name: 'ApprovalClaim',
          component: ApprovalClaim
        },
        {
          path: 'ApprovalFinancialClaim',
          name: 'ApprovalFinancialClaim',
          component: ApprovalFinancialClaim
        },
        {
          path: 'ApprovalOvertimeClaim',
          name: 'ApprovalOvertimeClaim',
          component: ApprovalOvertimeClaim
        },
        {
          path: 'ApplyLeave',
          name: 'ApplyLeave',
          component: ApplyLeave
        },
        {
          path: 'ApplyTimeOff',
          name: 'ApplyTimeOff',
          component: ApplyTimeOff
        },
        {
          path: 'ApplyClaim',
          name: 'ApplyClaim',
          component: ApplyClaim
        },
        {
          path: 'ApplyFinancialClaim',
          name: 'ApplyFinancialClaim',
          component: ApplyFinancialClaim
        },
        {
          path: 'ApplySalary',
          name: 'ApplySalary',
          component: ApplySalary
        },
        {
          path: 'Announcement',
          name: 'Announcement',
          component: Announcement
        },
        {
          path: 'TeamCalendar',
          name: 'TeamCalendar',
          component: TeamCalendar
        },
        {
          path: 'Performance',
          name: 'Performance',
          component: Performance
        },
        {
          path: 'InviteFriend',
          name: 'InviteFriend',
          component: InviteFriend
        },
        {
          path: 'AttendanceTimesheet',
          name: 'AttendanceTimesheet',
          component: AttendanceTimesheet
        },
        {
          path: 'ShiftCalendar',
          name: 'ShiftCalendar',
          component: ShiftCalendar
        },
        {
          path: 'AddStaff',
          name: 'AddStaff',
          component: AddStaff
        },
        {
          path: 'SettingCompany',
          name: 'SettingCompany',
          component: SettingCompany
        },
        {
          path: 'SettingDepartment',
          name: 'SettingDepartment',
          component: SettingDepartment
        },
        {
          path: 'SettingNotification',
          name: 'SettingNotification',
          component: SettingNotification
        },
        {
          path: 'SettingEvaluation',
          name: 'SettingEvaluation',
          component: SettingEvaluation
        },
        {
          path: 'SettingLeave',
          name: 'SettingLeave',
          component: SettingLeave
        },
        {
          path: 'SettingPersonalDetail',
          name: 'SettingPersonalDetail',
          component: SettingPersonalDetail
        },
        
        {
          path: 'SettingProfile',
          name: 'SettingProfile',
          component: SettingProfile
        },
        {
          path: 'SettingEmployment',
          name: 'SettingEmployment',
          component: SettingEmployment
        },
        {
          path: 'SettingContact',
          name: 'SettingContact',
          component: SettingContact
        },
        {
          path: 'SettingFamilyDetail',
          name: 'SettingFamilyDetail',
          component: SettingFamilyDetail
        },
        {
          path: 'SettingCompensation',
          name: 'SettingCompensation',
          component: SettingCompensation
        },
        {
          path: 'SettingDocument',
          name: 'SettingDocument',
          component: SettingDocument
        },
        {
          path: 'SettingEquipment',
          name: 'SettingEquipment',
          component: SettingEquipment
        },
        {
          path: 'SettingLeavePolicy',
          name: 'SettingLeavePolicy',
          component: SettingLeavePolicy
        },
        {
          path: 'SettingClaimPolicy',
          name: 'SettingClaimPolicy',
          component: SettingClaimPolicy
        },
        {
          path: 'SettingDisciplinary',
          name: 'SettingDisciplinary',
          component: SettingDisciplinary
        },
        {
          path: 'SettingAppSetting',
          name: 'SettingAppSetting',
          component: SettingAppSetting
        },
        {
          path: 'SettingClaim',
          name: 'SettingClaim',
          component: SettingClaim
        },
        {
          path: 'SettingAttendance',
          name: 'SettingAttendance',
          component: SettingAttendance
        },
        {
          path: 'SettingSubscription',
          name: 'SettingSubscription',
          component: SettingSubscription
        },
        {
          path: 'SettingYearlyForm',
          name: 'SettingYearlyForm',
          component: SettingYearlyForm
        },
        {
          path: 'SettingPayment',
          name: 'SettingPayment',
          component: SettingPayment
        },
        {
          path: 'SalaryPayroll',
          name: 'SalaryPayroll',
          component: SalaryPayroll
        },
        {
          path: 'PaymentVoucher',
          name: 'PaymentVoucher',
          component: PaymentVoucher
        },
        
       
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },

        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          name: "CoreUI Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },

   
    {
      path: "/",
      redirect: "/Index",
      name: "Index",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Index",
          name: "Index",
          component: Index,
        },
      ],
    },
    

    {
      path: "/",
      redirect: "/",
      name: "Login",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Login",
          name: "Login",
          component: LoginNew,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ForgotPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ForgotPassword",
          name: "ForgotPassword",
          component: ForgotPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "VerifyPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "VerifyPassword",
          name: "VerifyPassword",
          component: VerifyPassword,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "VerifyEmail",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "VerifyEmail",
          name: "VerifyEmail",
          component: VerifyEmail,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "Register",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "Register",
          name: "Register",
          component: Register,
        },
      ],
    },
    {
      path: "/",
      redirect: "/",
      name: "ResetPassword",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "ResetPassword",
          name: "ResetPassword",
          component: ResetPassword,
        },
      ],
    },
   
    
  ];
}
